import { motion } from 'framer-motion';
import { Clock3, ShieldCheck, Sparkles } from 'lucide-react';

export default function MaintenancePage() {
  const highlights = [
    {
      icon: Sparkles,
      title: 'Améliorations en cours',
      description: 'Nous peaufinons le site pour proposer une expérience plus fluide et plus élégante.'
    },
    {
      icon: ShieldCheck,
      title: 'Intervention sécurisée',
      description: 'La maintenance est réalisée côté plateforme afin de remettre le site en ligne proprement.'
    },
    {
      icon: Clock3,
      title: 'Retour rapide',
      description: 'Le service revient dès que les vérifications finales sont terminées.'
    }
  ];

  return (
    <div className="relative min-h-screen overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(232,196,184,0.35),_transparent_42%),linear-gradient(135deg,_#fdfcf8_0%,_#f7e7ce_48%,_#f1d7d1_100%)]">
      <div className="absolute inset-0 opacity-40">
        <div className="absolute left-[8%] top-20 h-40 w-40 rounded-full bg-white blur-3xl" />
        <div className="absolute bottom-12 right-[10%] h-52 w-52 rounded-full bg-[var(--rose-gold)]/40 blur-3xl" />
      </div>

      <div className="relative mx-auto flex min-h-screen max-w-6xl items-center px-6 py-16">
        <div className="grid w-full gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55 }}
          >
            <div className="mb-6 inline-flex items-center gap-3 border border-white/70 bg-white/80 px-4 py-2 text-xs uppercase tracking-[0.35em] text-[var(--charcoal)] shadow-sm backdrop-blur">
              <span className="h-2 w-2 rounded-full bg-[var(--gold)]" />
              Madame DSRS
            </div>

            <h1 className="max-w-3xl text-5xl font-light leading-none text-[var(--charcoal)] md:text-6xl">
              Site temporairement en maintenance
            </h1>

            <p className="mt-6 max-w-2xl text-base leading-8 text-[var(--charcoal)]/72 md:text-lg">
              Nous réalisons une intervention technique pour remettre le site public en ligne dans les meilleures conditions.
              Merci de votre patience.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 border border-[var(--champagne)] bg-white/85 px-5 py-3 text-sm text-[var(--charcoal)] shadow-sm backdrop-blur">
              <span className="h-2.5 w-2.5 rounded-full bg-amber-500" />
              Réouverture dès la fin des vérifications
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 32 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.12 }}
            className="border border-white/70 bg-white/88 p-8 shadow-[0_30px_80px_rgba(43,43,43,0.10)] backdrop-blur"
          >
            <p className="mb-6 text-xs uppercase tracking-[0.35em] text-[var(--charcoal)]/50">
              Mise à jour en cours
            </p>

            <div className="space-y-5">
              {highlights.map((item) => (
                <div key={item.title} className="flex gap-4 border-b border-[var(--champagne)]/70 pb-5 last:border-b-0 last:pb-0">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[var(--champagne)] text-[var(--charcoal)]">
                    <item.icon size={20} />
                  </div>
                  <div>
                    <h2 className="text-xl text-[var(--charcoal)]">{item.title}</h2>
                    <p className="mt-1 text-sm leading-7 text-[var(--charcoal)]/65">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
